import { Component, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { FileManagementService } from '@core/services/file-management.service';
import { SnackBarService } from '@core/services/snack-bar.service';
import { DialogService } from '@shared/services/dialog-service';
import { IQueryState } from '@shared/store/reducers/query.reducer';
import {BreadcrumbModel} from '@shared/models/breadcrumb.model';
import {InvalidateSubject} from '@shared/helpers/invalidate.subject';
import {Subject} from 'rxjs';
import {ActivatedRoute, Router} from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import {CommandService} from '@core/services/command.service';
import { SecurityState } from '@shared/store/reducers/security.reducer';
import { FileManagerService } from '../../services/file-manager.service';
import { DriveComponent } from '../drive/drive.component';
import {ShareItemService} from "@shared/services/share-item.service";
import {TranslationService} from "../../../translation/services/translation.service";

@Component({
    standalone: false,
    selector: 'particle-shared-with-me',
  templateUrl: './shared-with-me.component.html',
  styleUrls: ['./shared-with-me.component.scss']
})
export class SharedWithMeComponent extends DriveComponent implements OnInit {

  breadcrumbs: BreadcrumbModel[];
  driveId: string;
  folderId: string;
  parentId: string;
  sourceKey: string;
  invalidateSubject: InvalidateSubject;
  public ngUnsubscribe = new Subject<void>();
  constructor(protected store: Store<IQueryState>, protected activatedRoute: ActivatedRoute,
              protected dialog: MatDialog, protected commandService: CommandService, protected router: Router,
              protected dialogService: DialogService,
              protected fileManagementService: FileManagementService,
              protected snackBarService: SnackBarService,
              protected fileManagerService: FileManagerService,
              protected securityStore: Store<SecurityState>,
              shareItemService: ShareItemService,
              translationService: TranslationService) {
    super(store, activatedRoute, dialog, commandService, router, dialogService, fileManagementService, snackBarService, fileManagerService, securityStore, shareItemService, translationService);

    this.sourceKey = 'SharedWithMeDirectoryEntry';
    this.invalidateSubject = new InvalidateSubject();
    this.breadcrumbs = [
      <BreadcrumbModel>{
        id : 'Repository',
        title: 'Repository',
        relativeUrl: 'repository',
        type: 'Repository'
      },
      <BreadcrumbModel> {
        id : 'SharedWithMe',
        title: 'Shared with Me',
        relativeUrl: 'shared-with-me'
      }
    ];
  }

  ngOnInit() {
  }
  // onGridCellValueChange($event) {
  //   if ($event.cells) {
  //     this.itemEmited($event);
  //   } else if ($event.action) {
  //     switch ($event.action.id) {
  //       case 'Download':
  //         this.store.dispatch(new DownloadFileAction($event.item.id, $event.item.cells.Name.displayText, this.sourceKey));
  //         break;
  //     }
  //   }
  // }
  //
  // private itemEmited($event) {
  //   this.store.dispatch(new DownloadFileAction($event.id, $event.cells.Name.displayText, this.sourceKey));
  // }
}
